export function initCategories() {
  var newLi = document.createElement("li");
  newLi.classList.add("cat-item", "cat-item--featured");

  var newAnchor = document.createElement("a");
  newAnchor.href = "/aktuelles";
  newAnchor.textContent = "Alle";

  newLi.appendChild(newAnchor);

  var ulElement = document.querySelector(".wp-block-categories-list");

  ulElement.insertBefore(newLi, ulElement.firstChild);
}
